<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [MensajeMostrar]="'&iquest;Estas seguro de cerrar la sesi&oacute;n?'" [TituloMostrar]="'salir'" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<seleccionaliadocanal #appseleccionaliadocanal (SeleccionoAliadoCanal)="SeleccionoAliadoCanal($event)" (CambioAliadoCanal)="CambioAliadoCanal($event)"></seleccionaliadocanal>

<div class="sheet row">
    <div class="col-4 text-center">
        <button type="button" mat-button (click)="sidenav.toggle()" class="btntogle mbl">
            <mat-icon aria-hidden="false" aria-label="Example home icon">menu</mat-icon>
        </button>
    </div>
    <div class="col-4">
        <button mat-fab class="btnaddafiliado d-lg-none" (click)="AccionBoton()" *ngIf="isMenuOpen === false">
            <mat-icon>{{menuService.IconoAdicionarServicio}}</mat-icon>
        </button>
    </div>
    <div class="col-4 text-center">
        <button class="btnsheet">
            <!-- <mat-icon>search</mat-icon> -->
        </button>
    </div>
</div>

<mat-sidenav-container id="sidenavContainer" fullscreen>

    <mat-sidenav mode="Over" hasBackdrop="False" #sidenav id="sidenav" [class.menu-open]="isMenuOpen" [class.menu-close]="!isMenuOpen" [position]="tamanoAppService.mostrarModoEscritorio ? 'end' : ''" [opened]="tamanoAppService.mostrarModoEscritorio ? true : false">
        <div class="lineaversion"><span>Version 1.20</span></div>
        <a type="button" (click)="navegarPanelPrincipal()" class="logomenu" *ngIf="TemaActivoGlobal()">
            <img src="assets/icons/icon-128x128.png" alt="">
        </a>
        <a type="button" (click)="navegarPanelPrincipal()" class="logomenu" *ngIf="TemaActivoSura()">
            <img src="assets/img/sura/isotipo_sura.png" alt="">
        </a>
        <a type="button" (click)="navegarPanelPrincipal()" class="logomenu" *ngIf="TemaActivoAquaShield()">
            <img src="assets/img/aquashield/isotipo_aquashield.png" alt="">
        </a>
        <a type="button" (click)="navegarPanelPrincipal()" class="logomenu" *ngIf="TemaActivoCobelen()">
            <img src="assets/img/cobelen/isotipo_cobelen.png" alt="">
        </a>
        <div class="toglemenu">
            <button type="button" mat-button (click)="onToolbarMenuToggle()" class="btntogle esc">
                <mat-icon aria-hidden="false" aria-label="Example home icon">menu</mat-icon>
            </button>
            <mat-slide-toggle (click)="CerrarSesion()" [(ngModel)]="cerrarSesionUsuario" class="slidesesion"></mat-slide-toggle>
        </div>

        <div class="sucursal">
            <div class="usermenu">
                <h3>{{this.utilitariosService.VerificarContieneDatos(this.autenticacionService.UsuarioActivo) ? autenticacionService.UsuarioActivo.nombre : ''}}</h3>
                <span>Menu opciones</span>
            </div>

            <div class="aliado" *ngIf="this.autenticacionService.CanalSeleccionado > 0">
                <a type="button" (click)="CambiarCanal()">
                    <h3>{{this.autenticacionService.DescripcionAliadoSeleccionado}}</h3>
                </a>
            </div>

            <a type="button" (click)="CambiarCanal()" *ngIf="this.autenticacionService.CanalSeleccionado > 0">
                <mat-select [(ngModel)]="autenticacionService.CanalSeleccionado" [disabled]="true" class="readonly-block">
                    <mat-option [value]="item.idCanal" *ngFor="let item of this.autenticacionService.ListaCanales">
                        <div class="contexp">
                            <div class="exptitle">
                                <h3>{{item.canal}}</h3>
                            </div>
                        </div>
                    </mat-option>
                </mat-select>
            </a>
        </div>
        <ul class="Globalnavside">
            <li class="itemMenu" *ngFor="let itemMenu of this.menuService.MenusPadre()">
                <mat-icon class="iconomenu" aria-hidden="false" aria-label="Example home icon" *ngIf="this.menuService.TieneHijos(itemMenu)" [title]="itemMenu.nombreMenu">{{itemMenu.icono}}</mat-icon>
                <mat-icon class="iconomenu" aria-hidden="false" aria-label="Example home icon" *ngIf="!this.menuService.TieneHijos(itemMenu)" (click)="AccionMenu(itemMenu)" type="button" [title]="itemMenu.nombreMenu">{{itemMenu.icono}}</mat-icon>

                <ul *ngIf="this.menuService.TieneHijos(itemMenu)">
                    <li *ngFor="let itemMenuHijo of this.menuService.HijosMenu(itemMenu)" type="button" (click)="AccionMenu(itemMenuHijo)">
                        <mat-icon class="iconomenu" aria-hidden="false" aria-label="Example home icon">{{itemMenuHijo.icono}}</mat-icon>{{itemMenuHijo.nombreMenu}}
                    </li>
                </ul>
            </li>

            <li *ngFor="let itemMenu of this.menuService.MenusPadre()">
                <mat-expansion-panel hideToggle>
                    <mat-expansion-panel-header>
                        <mat-icon class="iconomenu" aria-hidden="false" aria-label="Example home icon" *ngIf="this.menuService.TieneHijos(itemMenu)">{{itemMenu.icono}}</mat-icon>
                        <div *ngIf="this.menuService.TieneHijos(itemMenu)">
                            {{itemMenu.nombreMenu}}
                        </div>

                        <mat-icon class="iconomenu" aria-hidden="false" aria-label="Example home icon" *ngIf="!this.menuService.TieneHijos(itemMenu) && tamanoAppService.mostrarModoEscritorio" (click)="AccionMenu(itemMenu)" (click)="onToolbarMenuToggle()">{{itemMenu.icono}}</mat-icon>
                        <a type="button" (click)="AccionMenu(itemMenu)" (click)="onToolbarMenuToggle()" *ngIf="!this.menuService.TieneHijos(itemMenu) && tamanoAppService.mostrarModoEscritorio">
                            {{itemMenu.nombreMenu}}
                        </a>

                        <mat-icon class="iconomenu" aria-hidden="false" aria-label="Example home icon" *ngIf="!this.menuService.TieneHijos(itemMenu) && !tamanoAppService.mostrarModoEscritorio" (click)="AccionMenu(itemMenu)" (click)="sidenav.toggle()">{{itemMenu.icono}}</mat-icon>
                        <a type="button" (click)="AccionMenu(itemMenu)" (click)="sidenav.toggle()" *ngIf="!this.menuService.TieneHijos(itemMenu) && !tamanoAppService.mostrarModoEscritorio">
                            {{itemMenu.nombreMenu}}
                        </a>
                    </mat-expansion-panel-header>
                    <mat-expansion-panel *ngIf="this.menuService.TieneHijos(itemMenu)">
                        <mat-expansion-panel-header *ngFor="let itemMenuHijo of this.menuService.HijosMenu(itemMenu)">
                            <mat-icon class="iconomenu" aria-hidden="false" (click)="onToolbarMenuToggle()" *ngIf="tamanoAppService.mostrarModoEscritorio">{{itemMenuHijo.icono}}</mat-icon>
                            <a type="button" (click)="AccionMenu(itemMenuHijo)" (click)="onToolbarMenuToggle()" *ngIf="tamanoAppService.mostrarModoEscritorio">
                                {{itemMenuHijo.nombreMenu}}
                            </a>

                            <mat-icon class="iconomenu" aria-hidden="false" (click)="AccionMenu(itemMenuHijo)" (click)="sidenav.toggle()" *ngIf="!tamanoAppService.mostrarModoEscritorio">{{itemMenuHijo.icono}}</mat-icon>
                            <a type="button" (click)="AccionMenu(itemMenuHijo)" (click)="sidenav.toggle()" *ngIf="!tamanoAppService.mostrarModoEscritorio">
                                {{itemMenuHijo.nombreMenu}}
                            </a>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>
                </mat-expansion-panel>
            </li>
        </ul>
    </mat-sidenav>

    <mat-sidenav-content>
        <div class="lineheader"></div>
        <div class="Globalcontainer">
            <div class="row mt-4">
                <div class="col-md-10 col-8">
                    <h1><a type="button" (click)="navegarPanelPrincipal()">
                        Hola, {{this.ObtenerNombreUsuario()}}
                    </a></h1>

                    <p>Bienvenido - última conexión {{this.utilitariosService.VerificarContieneDatos(this.autenticacionService.UsuarioActivo) ? this.autenticacionService.UsuarioActivo.fechaUltimoAcceso : '' | date:'medium'}}</p>
                </div>

                <div class="col-md-2 col-4 text-center mt-4 d-flex flex-row-reverse contenedorbotones">
                    <div class="p-1" *ngIf="this.tamanoAppService.mostrarModoEscritorio">
                        <button type="button" mat-button (click)="onToolbarMenuToggle()" class="btntogleprincipal esc">
                            <mat-icon aria-hidden="false" aria-label="Example home icon">menu</mat-icon>
                        </button>
                    </div>
                    <div class="p-1">
                        <mat-slide-toggle (click)="CerrarSesion()" [(ngModel)]="cerrarSesionUsuario" class="slidesesionprincipal"></mat-slide-toggle>
                    </div>
                    <div class="p-1" *ngIf="VerificarMostrarExpedientes() && !this.mostrarCargandoExpediente">
                        <a class="botonabrirfirmaelectronica" type="button" (click)="ejecutarSincronizacionExpediente()">
                            <mat-icon>cloud_download</mat-icon>
                        </a>
                    </div>
                    <div class="p-1" *ngIf="VerificarMostrarExpedientes() && this.mostrarCargandoExpediente">
                        ...
                    </div>
                    <div class="p-1" *ngIf="VerificarMostrarFirmaElectronica()">
                        <a class="botonabrirfirmaelectronica" type="button" (click)="abrirModalFirmaElectronica()">
                            <img src="assets/icons/Sign-Icon.svg" alt="">
                        </a>
                    </div>
                    <div class="p-1" *ngIf="VerificarMostrarOperacionesReembolso()">
                        <a class="botonabrirfirmaelectronica" type="button" (click)="abrirModalOperacionesReembolso()">
                            <mat-icon>room</mat-icon>
                        </a>
                    </div>
                </div>

            </div>

            <div class="contenedordatos">
                <componenteprincipal #componenteprincipal [Componente]="ComponenteActivo" *ngIf="this.autenticacionService.EstaAutenticado()"></componenteprincipal>
            </div>

        </div>
        <footer class="gobalfooter">
            <globalfooter></globalfooter>
        </footer>

    </mat-sidenav-content>


</mat-sidenav-container>